import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ComplianceApiService } from './compliance-api.service';
import { ComplianceRequest, ComplianceRequestType } from './compliance.model';

@Injectable({ providedIn: 'root' })
export class ComplianceRequestsService {
    private readonly _api = inject(ComplianceApiService);

    private readonly _pendingRequests = signal<ComplianceRequest[]>([]);

    public readonly pendingRequests = this._pendingRequests.asReadonly();
    public readonly currentRequest = computed<ComplianceRequest | null>(() => this._pendingRequests()[0] ?? null);
    public readonly hasPendingRequests = computed(() => this._pendingRequests().length > 0);

    public loadPendingRequests(): Observable<ComplianceRequest[]> {
        return this._api.getComplianceRequests().pipe(tap((requests) => this._pendingRequests.set(requests)));
    }

    public completeRequest(type: ComplianceRequestType): Observable<void> {
        return this._api.completeRequest(type).pipe(
            tap(() => this._pendingRequests.update((requests) => requests.filter((r) => r.type !== type)))
        );
    }

    public completeAllRequests(types: ComplianceRequestType[]): Observable<void> {
        return this._api.completeRequests(types).pipe(
            tap(() => this._pendingRequests.set([]))
        );
    }

    public clear(): void {
        this._pendingRequests.set([]);
    }
}
